<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.stopResumeLawsuitRequest.title">
      <v-row>
        <span class="span-request-type">
          {{ local.caseRelatedRequest.stopResumeLawsuitRequest.subRequestType }}
        </span>
      </v-row>
      <v-row>
        <v-col cols="6">
          <div
            v-if="formModel.StopOrContinue.Value == stopOrResumeLawsuitRequestTypeValues.stopLawsuitRequestType"
            class="span-request-subType"
          >
            <span>
              {{ local.stopOrResumeLawsuitRequestType.stopLawsuitRequestType }}
            </span>
          </div>
          <div
            v-if="formModel.StopOrContinue.Value == stopOrResumeLawsuitRequestTypeValues.resumeLawsuitRequestType"
            class="span-request-subType"
          >
            <span>
              {{ local.stopOrResumeLawsuitRequestType.resumeLawsuitRequestType }}
            </span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="formModel.StopOrContinue.Value == stopOrResumeLawsuitRequestTypeValues.stopLawsuitRequestType"
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.caseRelatedRequest.stopResumeLawsuitRequest.stopDurationName"
            :value.sync="formModel.StopOrContinue.Duration"
            :items="stopDurations"
            item-text="name"
            item-value="id"
            :disabled="isViewMode"
            validates="required"
          ></naj-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-if="formModel.StopOrContinue.Value == stopOrResumeLawsuitRequestTypeValues.stopLawsuitRequestType"
          cols="6"
        >
          <span class="request-reasons-warning">
            <v-icon color="#FAAD14">
              mdi-alert
            </v-icon>
            {{ local.caseRelatedRequest.stopResumeLawsuitRequest.warningMessage }}
          </span>
        </v-col>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum, stopOrResumeLawsuitRequestTypeValues, StopOrResumeRequestStatus } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'StopResumeLawsuitRequest',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      caseParties: [],
      stopOrResumeLawsuitRequestTypeValues,
    };
  },
  computed: {
    ...mapLUTState(['stopDurations']),
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
  },
  watch: {},
  mounted() {
    if (this.formModel) {
      this.readCurrentUserInfo();

      this.$set(this.formModel, 'StopOrContinue', this.formModel.StopOrContinue ? this.formModel.StopOrContinue : {
        Name: '',
        Value: '',
        Duration: '',
      });
      this.loading = true;
      
      this.IsCaseStoppedOrResume(this.formModel.case.objectKey)
        .then((res) => {
           if (res.data.status == StopOrResumeRequestStatus.Stop) {
               this.isStoppedCase = true;
               this.formModel.StopOrContinue.Value = stopOrResumeLawsuitRequestTypeValues.resumeLawsuitRequestType;
               this.formModel.StopOrContinue.Name = this.local.stopOrResumeLawsuitRequestType.resumeLawsuitRequestType;
           }
           else if (res.data.status == StopOrResumeRequestStatus.Resume) { 
               this.formModel.StopOrContinue.Value = stopOrResumeLawsuitRequestTypeValues.stopLawsuitRequestType;
               this.formModel.StopOrContinue.Name = this.local.stopOrResumeLawsuitRequestType.stopLawsuitRequestType;
           }
      })
          .finally(() => (this.loading = false));

      if (this.formModel.StopOrContinue && this.formModel.StopOrContinue.Duration) {
        this.formModel.StopOrContinue.Duration = parseInt(this.formModel.StopOrContinue.Duration);
      }
    }

    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };

    this.getCaseBasicParties(params)
      .then((res) => {
        this.caseParties = res.data;
      })
      .finally(() => (this.loading = false));
  },
  created() { },
  methods: {
    ...mapActions([
      'getCaseBasicParties',
      'IsCaseStoppedOrResume',
    ]),
    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.request-reasons-warning {
  font-size: 16px;
  color: #faad14;
}

.span-request-type {
  font-size: 18px;
  font-weight: bold;
}

.span-request-subType {
  font-size: 18px;
}
</style>